import { isNil } from "../utils/primitives";

export class InputRegistry {
  // TODO: Disabling this as it's causing issues in kanopi-web
  // (missing class properties) when it shouldn't (preset-env should
  // manage this, right?).
  // inputs: TODO;

  constructor(inputs) {
    this.inputs = inputs || {};
  }

  add(type, Component) {
    this.inputs[type] = Component;
  }

  getByType(type, defaultValue) {
    if (isNil(type)) {
      return null;
    }
    const Component = this.inputs[type.toLowerCase()] || defaultValue;
    if (!Component) {
      throw new MissingInputWidget(`Missing input widget: ${type}`);
    }
    return Component;
  }
}

export class MissingInputWidget extends Error {}
